import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { useDispatch, useSelector } from "react-redux";
import TableDataComponent from "../../components/parking-excel/TableDataComponent";
import TotalLineComponent from "../../components/parking-excel/TotalLineComponent";
import { setLayoutDashboardTitle } from "../../store/ui-slice";
import { useNavigate } from "react-router-dom";
import useAPIRequest from "../../custom_hooks/simple/useAPIRequest";
import { format } from "date-fns";
import onErrorToast from "../../utils/OnErrorToast";
import onSuccessToast from "../../utils/OnSuccessToast";
import { Dropdown } from "primereact/dropdown";
import copyToClipboard from "../../utils/parkir-import-excel/CopyToClipboard";

const title = "Edit Data";

const defaultSingleData = {
  id: -1,
  no: 0,
  jenis: "",
  masuk_tanggal: format(Date.now(), "yyyy-MM-dd HH:mm:ss"),
  masuk_op: "",
  keluar_tanggal: format(Date.now(), "yyyy-MM-dd HH:mm:ss"),
  keluar_kasir: "",
  nomor_plat: "",
  lama: "",
  pembayaran: "",
  overnight: "",
  tiket_hilang: "",
  nomor_manual: "",
  nomor_voucher: "",
  jumlah: 0,
  jumlah_edited: 0,
};

const filterOptions = [
  { name: "Semua", value: "semua" },
  { name: "Mobil", value: "mobil" },
  { name: "Sepeda", value: "sepeda" },
];

const jumlahOptions = [
  { name: "Asli", value: "jumlah" },
  { name: "Edited", value: "jumlah_edited" },
];

const EditDataPage = (props) => {
  const navigate = useNavigate();
  const permissions = useSelector((state) => state.auth.permissions);

  const toastRef = useRef(null);
  const dispatch = useDispatch();
  const [date, setDate] = useState([new Date(), new Date()]);
  const [datas, setDatas] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[0].value);
  const [selectedJumlahOption, setSelectedJumlahOption] = useState(
    jumlahOptions[0].value
  );
  const [jenisJumlah, setJenisJumlah] = useState(jumlahOptions[0].value);
  const { requestGet, requestDelete, requestPost, loading } = useAPIRequest();

  useEffect(() => {
    if (!permissions.includes("view editdata")) {
      navigate("/");
    }
    dispatch(setLayoutDashboardTitle({ title }));

    reloadData();
  }, []);

  const handleCopyData = () => {
    copyToClipboard({
      fields: [
        "no",
        "jenis",
        "masuk_tanggal",
        "masuk_op",
        "keluar_tanggal",
        "keluar_kasir",
        "nomor_plat",
        "lama",
        "jumlah",
        "jumlah_edited",
      ],
      data: datas,
    });
    onSuccessToast({
      toast: toastRef,
      message: "Data berhasil di-copy",
      data: {},
    });
  };

  const generateFilter = () => {
    let filter = "";
    let firstDate, secondDate;
    if (date.length > 0) {
      firstDate = date[0];
    }
    if (date.length > 1) {
      secondDate = date[1];
    }

    if (firstDate && secondDate) {
      const nextDate = new Date(secondDate);
      nextDate.setDate(nextDate.getDate() + 1);
      filter += `keluar_tanggal:>=:${format(
        firstDate,
        "yyyy-MM-dd"
      )} 00:00:00;keluar_tanggal:<:${format(nextDate, "yyyy-MM-dd")} 00:00:00`;
    } else if (firstDate) {
      const nextDate = new Date(firstDate);
      nextDate.setDate(nextDate.getDate() + 1);
      filter += `keluar_tanggal:>=:${format(
        firstDate,
        "yyyy-MM-dd"
      )} 00:00:00;keluar_tanggal:<:${format(nextDate, "yyyy-MM-dd")} 00:00:00`;
    }

    if (selectedFilter && selectedFilter !== "semua") {
      filter += `;jenis:contains:%${selectedFilter}%`;
    }

    return filter;
  };

  const saveData = async ({ data, index }) => {
    if (data.id <= 0) {
      delete data.id;
    }

    const postResult = await requestPost({
      fullUrl: "api/transaksi/dataparkir/save",
      isForm: false,
      body: data,
      onSuccess: ({ message, data: d }) => {
        if (d) {
          const copyData = [...datas];
          copyData[index] = d;
          setDatas(copyData);

          onSuccessToast({
            toast: toastRef,
            message: "Data berhasil disimpan",
            data: {},
          });
        }
      },
      onError: ({ message, data }) => {
        onErrorToast({
          toast: toastRef,
          message: "Gagal menyimpan data",
          data: {},
        });
      },
    });
  };

  const deleteData = async (data) => {
    const deleteResult = await requestDelete({
      fullUrl: "api/transaksi/dataparkir/delete",
      isForm: false,
      ids: [data.id],
      onSuccess: ({ message, data: d }) => {
        if (d) {
          const newData = datas.filter((el) => el.id !== data.id);
          setDatas(newData);

          onSuccessToast({
            toast: toastRef,
            message: "Data berhasil dihapus",
            data: {},
          });
        }
      },
      onError: ({ message, data }) => {
        onErrorToast({
          toast: toastRef,
          message: "Gagal menghapus data",
          data: {},
        });
      },
    });
  };

  const reloadData = () => {
    setDatas([]);
    requestGet({
      fullUrl: "api/transaksi/dataparkir/data",
      params: {
        filter: generateFilter(),
        page: 1,
        take: 100000,
        order: "id",
        order_method: "ASC",
      },
      onSuccess: ({ pagination, message, data }) => {
        if (data) {
          for (let i = 0; i < data.length; i++) {
            data[i].no = i + 1;
          }
          setDatas(data);
        }
        setJenisJumlah(selectedJumlahOption);
      },
      onError: ({ message, data }) => {},
    });
  };

  const handleTambahData = (event) => {
    event.preventDefault();
    const newData = [...datas, { ...defaultSingleData }];
    const randomNegativeNumber = Math.floor(Math.random() * -1000);
    newData[newData.length - 1].id = randomNegativeNumber;
    setDatas(newData);
  };

  const reloadHandler = (event) => {
    reloadData();
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <Toast ref={toastRef} />
      <ConfirmDialog />
      <div className="elevated-card col-start-start w-full gap-4">
        {/* header - tanggal & upload */}
        <div className="row-between-center gap-3 w-full">
          <div className="row-start-center gap-2">
            <span>Tanggal</span>
            <Calendar
              className="max-w-[17rem] w-[17rem]"
              selectionMode="range"
              value={date}
              onChange={(e) => setDate(e.value)}
              showIcon
            />
            <Dropdown
              value={selectedFilter}
              onChange={(e) => setSelectedFilter(e.value)}
              options={filterOptions}
              optionLabel="name"
              className="w-[9rem]"
            />
            <Dropdown
              value={selectedJumlahOption}
              onChange={(e) => setSelectedJumlahOption(e.value)}
              options={jumlahOptions}
              optionLabel="name"
              className="w-[8rem]"
            />
            <Button
              label="Load"
              icon="pi pi-refresh"
              loading={loading}
              onClick={reloadHandler}
            />
          </div>
          <div className="row-end-center gap-2">
            <Button
              label="Tambah Data"
              icon="pi pi-plus"
              onClick={handleTambahData}
            />
            <Button label="Copy" icon="pi pi-copy" onClick={handleCopyData} />
          </div>
        </div>

        {/* total */}
        <TotalLineComponent
          listData={datas}
          labelField={"jenis"}
          totalField={jenisJumlah}
        />

        {/* tabel */}
        <TableDataComponent
          data={datas}
          setData={setDatas}
          onSave={saveData}
          onDelete={deleteData}
          editable
        />
      </div>
    </div>
  );
};

export default EditDataPage;
